import { Component, OnInit,Directive, Input } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor() { }
  devloper={
   name:'Osmani Youcef',
   profile:'Full-Stack Developer (Js)',
   email:'osmani.youcef19@gmail.com',
   phone:'(+213) 542-61-23-29'
 };
 @Input() aboutMe= {
   p1:'I am a professional Web Developer with Specializations in Web Design, Web Development, with over 5 years of experience doing Front-End Development, and almost 2 years working with Back-End Development. Currently, I work as a Full-Stack web developer.',
   p2:'I also have experience of working with software like Photoshop Ilustrator and XD for creating web designs and prototypes.',
   p3:'I work hard and focus on providing great customer service and quality work.Will respond quickly to questions & concerns regarding work. Honest and transparent about my expertise and availability. Available for phone calls, emails, messages to get things done quickly.Thank You.'
  }
  skills = [
    { name: 'Node / Express / hapi'},
    { name: 'TypeScript / Angular / NestJs'},
    { name: 'NativeScript / kotlin '},
    { name: 'Git / GitLab / GitHub '},
    { name: 'Sql / No Sql'},
    { name: 'Angular Material / BootStrap'},
    { name: 'Docker'}
  ];
  imgUrlaboutMe ="assets/img/testimonial-2.jpg";







  ngOnInit() {
  }

}
